import { Container, Typography, useTheme } from '@mui/material';

interface ChatWindowFooterProps {
  disclaimerText: string;
}

export const ChatWindowFooter = ({ disclaimerText }: ChatWindowFooterProps) => {
  const theme = useTheme();
  return (
    <Container sx={{ marginBottom: theme.spacing(4), padding: `0 !important` }}>
      <Typography variant="caption">{disclaimerText}</Typography>
    </Container>
  );
};
